import {
  addErrorInLine,
  messages,
  Translate,
  ValidateCSVError,
  ValidateCSVFieldErrors,
} from "../../../../../../../../components/Generic/UploadCSVFile/types";
import {
  CommodityCode,
  CommodityCodeTemplateCSV,
  RegionCommodityCode,
} from "../../../../../../../../models/commodity.code";
import { getHSCode, REGEX_TEST_8_TO_10_DIGITS } from "../../utils";

const getTemplateColumnName = (translate: Translate) => {
  return {
    code: translate("code"),
    regions: translate("regions"),
    statisticalClassification: translate("statisticalClassification"),
  };
};

const validateCSVField = (
  dataItem: CommodityCodeTemplateCSV,
  hscodes: CommodityCode[],
  line: number,
  lineErrors: ValidateCSVFieldErrors,
  regions: RegionCommodityCode[],
  translate: Translate
) => {
  const templateColumnName = getTemplateColumnName(translate);

  let dataItemValid = true;

  const addError = (messageError: ValidateCSVError) => {
    addErrorInLine(lineErrors, line, translate(messageError), () => {
      dataItemValid = false;
    });
  };

  const message = messages(translate);

  if (!dataItem.code) addError(message.filled(templateColumnName.code));
  if (REGEX_TEST_8_TO_10_DIGITS.test(dataItem.code)) {
    const hscode = getHSCode(dataItem.code);

    if (!hscodes.find((item) => item.hscode === hscode)) {
      addError(message.notfound(translate("hscode"), dataItem.code));
    }
  } else {
    addError(message.invalid(templateColumnName.code, dataItem.code));
  }

  if (!dataItem.statisticalClassification)
    addError(message.filled(templateColumnName.statisticalClassification));

  if (dataItem.regions) {
    const regionNames = dataItem.regions.split(",").map((region) => region.trim());

    for (const regionName of regionNames) {
      if (!regions.find(({ name }) => name === regionName)) {
        addError(message.invalid(templateColumnName.regions, regionName));
      }
    }
  } else {
    addError(message.filled(templateColumnName.regions));
  }

  return dataItemValid;
};

export const validateCSVFields = (
  data: CommodityCodeTemplateCSV[],
  lineErrors: ValidateCSVFieldErrors,
  translate: Translate,
  hscodes: CommodityCode[] = [],
  regions: RegionCommodityCode[] = []
) => {
  const valids = new Array(data.length).fill(true, 0);

  data.forEach((dataItem, index) => {
    const line = index + 1;

    valids[index] = validateCSVField(dataItem, hscodes, line, lineErrors, regions, translate);
  });

  return { valid: valids.every((valid) => valid) };
};
